module.exports = __webpack_public_path__ + "6a1a16ba0018593b2cb05e68fc1c82a3.fbx";